import Vue from "vue";
import Meta from "vue-meta";

Vue.use(Meta, {
  keyName: "meta",
  attribute: "data-meta",
  tagIDKeyName: "vm-id",
  refreshOnceOnNavigation: true
});
